import { Select } from "antd";

export const divisionOptions = [
  { value: "livestock", label: "Животноводство" },
  { value: "crop_production", label: "Растеневодство" },
  { value: "feed_plan", label: "План по кормам" },
  { value: "headcount_plan", label: "План по поголовью" },
  { value: "breeding_plan", label: "План по осеменению" },
  { value: "veterinary_plan", label: "План ветеринарных мероприятий" },
];
export const dataSourceStatusOptions = [
  { value: "LIVESTOCK_POPULATION", label: "Популяция скота" },
  { value: "WATER_VOLUME", label: "Объем воды" },
  { value: "SOWING_PLOTS", label: "Севойные участки" },
];

export const territorialUnitOptionsValue = {
  REPUBLIC: "REPUBLIC",
  REGION: "REGION",
  AREA: "AREA",
  CITY_OF_REPUBLICAN_SIGNIFICANCE: "CITY_OF_REPUBLICAN_SIGNIFICANCE",
  CITY_OF_REGIONAL_SIGNIFICANCE: "CITY_OF_REGIONAL_SIGNIFICANCE",
  CITY_OF_AREA_SIGNIFICANCE: "CITY_OF_AREA_SIGNIFICANCE",
  URBAN_VILLAGE: "URBAN_VILLAGE",
  VILLAGE: "VILLAGE",
  RURAL_DISTRICT: "RURAL_DISTRICT",
  RURAL: "RURAL",
} as const;

export type TerritorialUnitOptionsValue =
  (typeof territorialUnitOptionsValue)[keyof typeof territorialUnitOptionsValue];

export const territorialUnitOptions: Array<{
  value: TerritorialUnitOptionsValue;
  label: string;
}> = [
  { value: "REPUBLIC", label: "РЕСПУБЛИКА" },
  { value: "REGION", label: "РЕГИОН" },
  { value: "AREA", label: "ОБЛАСТЬ" },
  {
    value: "CITY_OF_REPUBLICAN_SIGNIFICANCE",
    label: "ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ",
  },
  {
    value: "CITY_OF_REGIONAL_SIGNIFICANCE",
    label: "ГОРОД РЕГИОНАЛЬНОГО ЗНАЧЕНИЯ",
  },
  { value: "CITY_OF_AREA_SIGNIFICANCE", label: "ГОРОД ЗНАЧИМОСТЬ РЕГИОНА" },
  { value: "URBAN_VILLAGE", label: "ГОРОДСКОЕ СЕЛО" },
  { value: "VILLAGE", label: "СЕЛО" },
  { value: "RURAL_DISTRICT", label: "РАСЕЛОК" },
  { value: "RURAL", label: "СЕЛО" },
];

type Props = {
  disebled?: boolean;
  value?: string;
  options: Array<{ value: string; label: string }>;
};

export const CustomSelect = ({ disebled, value, options }: Props) => {
  return (
    <Select
      value={value}
      disabled={disebled}
      style={{ width: 150 }}
      options={options}
    />
  );
};
